/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
import PASentry from "../../util/pa-sentry";

/**
 * currently this works for static methods only,
 * to give support for instance method check
 * https://gist.github.com/tugayilik/f574827ef31caf61b92de79b64dfa47e
 */
function tryCatchProxy(superClass: any) {
  const staticMethods = Object.getOwnPropertyNames(superClass)
    .filter((prop) => typeof superClass[prop] === "function");

  const staticHandler = (fn: any) => (...args: any[]) => {
    try {
      return fn(...args);
    } catch (_: unknown) {
      const error = _ as Error;
      if (process.env.NODE_ENV === "development") {
        throw error;
      }
      PASentry.logException(new Error(`tryCatchProxy failed for - ${error.message}`), {}, { functionName: fn.name, ...args });
    }
  };

  staticMethods.forEach((_) => {
    superClass[_] = staticHandler(superClass[_]);
  });

  return superClass;
}

export default tryCatchProxy;
